import * as React from "react";
import { withNamespaces, WithNamespaces } from "react-i18next";
import {
  ProposalComment,
  ResponseTypes,
  PayloadArtwork,
  ResponseArtwork,
  AttachFile, ProposalArtwork
} from "src/redux/projects";
import { Loader } from "./Loader";
import { setUploadFiles } from "src/api/projects";
import { toast } from "react-toastify";
import { config } from "src/config/config";

interface Props {
  editCommentWithModal: (comment: ProposalComment) => void;
  readCommentWithModal: (comment: ProposalComment) => void;
  response: ResponseArtwork | undefined;
  loader: boolean;
  onSubmit: (
    payload: PayloadArtwork,
    response: ResponseArtwork | undefined,
    responseType: ResponseTypes
  ) => void;
  onChangeStep: (step: number) => void;
  proposal: ProposalArtwork;
  allComments: ProposalComment[];
  isLocked: boolean;
  step: number;
}
type PropsWithNamespaces = Props & WithNamespaces;

interface State {
  askedEveryone: string;
  summarizedEverything: string;
  comment: string;
  files: AttachFile[];
}
class ArtworkSidebar extends React.Component<PropsWithNamespaces, State> {
  state: State = {
    askedEveryone: "no",
    summarizedEverything: "no",
    files:
      this.props.proposal.responses[0].payload &&
      (this.props.proposal.responses[0].payload as PayloadArtwork).files
        ? (this.props.proposal.responses[0].payload as PayloadArtwork).files
        : [],
    comment: this.props.proposal.responses[0].payload
      ? this.props.proposal.responses[0].payload.comment
      : ""
  };
  onAskedEveryoneChange = e => {
    this.setState({
      askedEveryone: e.target.value
    });
  };
  onSummarizedEverythingChange = e => {
    this.setState({
      summarizedEverything: e.target.value
    });
  };

  onChangeFile = async ev => {
    try {
      if (ev.target.files[0].size > config.maxFileSizeUpload) {
        toast.error(this.props.t("proposal.files.maximumSizeExceeded"));
        return;
      }
      const file = await setUploadFiles(ev.target.files[0]);

      this.setState({
        files: [...this.state.files, file]
      });
    } catch (e) {
      if (e.response.data.message === "UNVALID_EXTENSION") {
        toast.error(this.props.t("proposal.files.unvalidExtension"));
        return;
      }
      toast.error("Upload files error");
    }
  };
  deleteFile = file => {
    this.setState({
      files: [...this.state.files.filter(f => f.id !== file.id)]
    });
  };
  onCommentChange = e => {
    this.setState({ comment: e.target.value });
  };

  sendValidated = e => {
    e.preventDefault();

    const commentsFromRedux = this.props.response
      ? (this.props.response.payload as PayloadArtwork).comments
      : [];

    // If there is no comment, we consider that user accept the proposal
    const responseType =
      commentsFromRedux.length === 0 && this.state.comment === ""
        ? ResponseTypes.Validated
        : ResponseTypes.Rejected;

    this.props.onSubmit(
      {
        askedEveryone: this.state.askedEveryone,
        summarizedEverything: this.state.summarizedEverything,
        comment: this.state.comment,
        files: this.state.files
      } as PayloadArtwork,
      this.props.response,
      responseType
    );
  };
  sendSaveAndWait = e => {
    e.preventDefault();
    this.props.onSubmit(
      {
        askedEveryone: this.state.askedEveryone,
        summarizedEverything: this.state.summarizedEverything,
        comment: this.state.comment,
        files: this.state.files
      } as PayloadArtwork,
      this.props.response,
      ResponseTypes.Pending
    );
  };

  render() {
    const currentResponseType = this.props.proposal.responses
      ? this.props.proposal.responses[0].responseType
      : ResponseTypes.Rejected;

    const globalComment =
      this.props.proposal.responses && this.props.proposal.responses[0].payload
        ? this.props.proposal.responses[0].payload.comment
        : "";
    return (
      <div className="sidebar-right">
        {/* view validation */}
        <div
          className={`step step-end ${this.props.step === 1 ? "active" : ""}`}
        >
          <div className="sidebar-right-infos flex-column">
            <p className="title mb-0">
              {this.props.t("proposal.pov.titleValidation")}
            </p>
            <div>
              <strong>
                {this.props.t("proposal.session")}
                {this.props.proposal.rank!==undefined && this.props.proposal.rank+1}
              </strong>
            </div>
          </div>
          <div className="sidebar-right-items d-flex flex-column ">
            <div className="flex-1 sidebar-right-items-item p-3 flex-column">
              <div className="w-100">
                <p className=" mt-4">
                  {this.props.t("proposal.artwork.validation.globalComment")}
                </p>
                <textarea
                  onChange={this.onCommentChange}
                  value={this.state.comment}
                  placeholder="..."
                />
              </div>
              <div className="pt-3">
                <label className="cursor-pointer">
                  <img
                    className="mr-2"
                    width="20px"
                    src="assets/svgs/clip.svg"
                  />
                  <input
                    type="file"
                    className="d-none"
                    onChange={this.onChangeFile}
                  />
                  {this.props.t("proposal.artwork.validation.fileUrl")}
                  <small className="ml-1">
                    {this.props.t("proposal.files.maximumSize")}
                  </small>
                </label>
                {this.state.files.length > 0 && (
                  <div>
                    <p className=" mt-2 mb-2">
                      {this.props.t("proposal.files.title")}
                    </p>
                    <div>
                      {this.state.files.map(file => (
                        <div className="d-flex" key={file.id}>
                          <a className="flex-1" target="_blank" href={file.url}>
                            <img
                              width="16px"
                              src="assets/svgs/outline-cloud_download.svg"
                            />
                            <small className="ml-2">{file.filename}</small>
                          </a>

                          <img
                            onClick={e => this.deleteFile(file)}
                            src="/assets/svgs/baseline-close.svg"
                            width="16px"
                            className="cursor-pointer"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="p-3">
              <div>
                <div className="d-flex align-items-center">
                  <span className="flex-1">
                    {this.props.t("proposal.artwork.validation.askedEveryone")}
                  </span>
                  <select
                    className={(this.state.askedEveryone!=='yes' ? 'highlight ':' ') + 'ml-2'}
                    onChange={this.onAskedEveryoneChange}
                    value={this.state.askedEveryone}
                  >
                    <option value="yes">{this.props.t("yes")}</option>
                    <option value="no">{this.props.t("no")}</option>
                  </select>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center  mt-2">
                  <span className="flex-1">
                    {this.props.t(
                      "proposal.artwork.validation.summarizedEverything"
                    )}
                  </span>

                  <select
                      className={(this.state.summarizedEverything!=='yes' ? 'highlight ':' ') + 'ml-2'}
                    onChange={this.onSummarizedEverythingChange}
                    value={this.state.summarizedEverything}
                  >
                    <option value="yes">{this.props.t("yes")}</option>
                    <option value="no">{this.props.t("no")}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="m-auto text-center w-100">
            <button
              onClick={e => this.props.onChangeStep(0)}
              className="btn btn-primary mb-0 orange"
            ><img
                className="ml-1"
                src="assets/svgs/right-chevron-white.svg"
                width="10px"
                style={{transform: 'rotate(180deg)'}}
            />&nbsp;&nbsp;
              {this.props.t("proposal.artwork.validation.btnBack")}
            </button>
            <button
              className="btn btn-primary mb-0"
              onClick={this.sendSaveAndWait}
            >
              {!this.props.loader && (
                <div>
                  {this.props.t("button.saveAndWait")}
                  <img
                    className="ml-1"
                    src="assets/svgs/right-chevron-white.svg"
                    width="10px"
                  />
                </div>
              )}
              {this.props.loader && <Loader />}
            </button>
            <button
              onClick={this.sendValidated}
              className="btn btn-primary"
              disabled={
                !(
                  this.state.summarizedEverything === "yes" &&
                  this.state.askedEveryone === "yes"
                )
              }
            >
              {!this.props.loader && (
                <div>
                  {this.props.t("button.validAndSend")}
                  <img
                    className="ml-1"
                    src="assets/svgs/right-chevron-white.svg"
                    width="10px"
                  />
                </div>
              )}
              {this.props.loader && <Loader />}
            </button>
          </div>
        </div>

        {/* view comments*/}
        <div
          className={`step step-start ${this.props.step === 0 ? "active" : ""}`}
        >
          <div className="sidebar-right-infos flex-column">
            <p className="title mb-0">
              {this.props.t("proposal.artwork.title")}
            </p>
            <div>
              <strong>
                {this.props.t("proposal.session")}
                {this.props.proposal.rank!==undefined && this.props.proposal.rank+1}
              </strong>
            </div>
          </div>
          <div
            className={`sidebar-right-items ${
              this.props.allComments.length > config.maxCommentCount ? "warning" : ""
            }`}
          >
            {this.props.allComments.map((r, index) => (
              <div
                key={r.id}
                className="sidebar-right-items-item align-items-center"
                onClick={e =>
                  !this.props.isLocked
                    ? this.props.editCommentWithModal(r)
                    : this.props.readCommentWithModal(r)
                }
              >
                <span className="pin mr-2">{index + 1}</span>
                {r.text && (
                  <p className="flex-1 mb-0">
                    {r.text.substring(0, 40)}
                    {r.text.length > 30 ? "..." : ""}
                  </p>
                )}
              </div>
            ))}
          </div>
          {!this.props.isLocked && (
            <div className="m-auto text-center">
              <p className="mt-4">{this.props.t("proposal.artwork.addPin")}</p>
              <p className="mt-4 mb-4">
                Note : vous pouvez effectuer jusqu'à {config.maxCommentCount} annotations. Les annotations supplémentaires feront l'objet d'une facturation complémentaire.
              </p>

              <button
                className="btn btn-primary"
                onClick={e => this.props.onChangeStep(1)}
              >
                {this.props.t("proposal.artwork.btn")}
                <img
                  className="ml-1"
                  src="assets/svgs/right-chevron-white.svg"
                  width="10px"
                />
              </button>
            </div>
          )}
          {this.props.isLocked && (
            <div className="m-auto  p-2">
              <span className="text-center font-weight-bold">
                {currentResponseType === ResponseTypes.Rejected && (
                  <span>
                    {this.props.t("proposal.artwork.validation.rejected")}
                  </span>
                )}
                {currentResponseType === ResponseTypes.Validated && (
                  <span>
                    {this.props.t("proposal.artwork.validation.accepted")}
                  </span>
                )}
              </span>
              <p className="pov align-items-center mt-2 mb-0 text-center">
                {globalComment}
              </p>
              {this.state.files.length > 0 && (
                <div className="text-left">
                  <p className=" mt-2 mb-2">
                    {this.props.t("proposal.files.title")}
                  </p>
                  <div>
                    {this.state.files.map(file => (
                      <div className="d-flex" key={file.id}>
                        <a className="flex-1" target="_blank" href={file.url}>
                          <img
                            width="16px"
                            src="assets/svgs/outline-cloud_download.svg"
                          />
                          <small className="ml-2">{file.filename}</small>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default withNamespaces()(ArtworkSidebar);



// WEBPACK FOOTER //
// ./src/components/ArtworkSidebar.tsx